<template>
  <div class="content" id="page-top">
    <validation-observer ref="observer" method="post">
      <h2 class="page-title">料金・納期検索</h2>

      <h4 class="page-sub-title pl-2 pl-md-4 mt-md-5">車両</h4>
      <div class="section-wrapper">
        <section class="trial-syaryo">
          <div class="section-child">
            <table class="table">
              <tr>
                <th>
                  車両タイプ
                  <span class="must">必須</span>
                </th>
                <td>
                  <div class="row">
                    <div class="col-md-9 col-lg-5">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required"
                        name="SYARYO_TYPE_KBN"
                      >
                        <b-form-select
                          ref="SYARYO_TYPE_KBN"
                          v-model="syaryo.SYARYO_TYPE_KBN"
                          :state="errors.length ? false : null"
                          :options="[{ value: '', text: '未選択' }].concat(...syaryoTypeKbnList)"
                          :disabled="calculated"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  車名
                  <span class="must">必須</span>
                </th>
                <td>
                  <validation-provider
                    v-slot="{ errors, touched }"
                    rules="required|max:20|char"
                    name="SYARYO_MEI"
                  >
                    <vue-simple-suggest
                      ref="SYARYO_MEI"
                      v-model="syaryo.SYARYO_MEI"
                      :class="[
                        'col-md-6 px-0 px-md-0',
                        {
                          'border-red':
                            (isVlidated || touched) && errors.length,
                        },
                      ]"
                      :max-suggestions="15"
                      :list="syameiList"
                      :styles="autoCompleteStyle"
                      placeholder="プリウス"
                      :disabled="calculated"
                      :filter-by-query="true"
                      maxlength="20"
                      @blur="syaryo.SYARYO_MEI = replaceChar(syaryo.SYARYO_MEI)"
                    />
                    <div
                      v-show="(isVlidated || touched) && errors.length"
                      class="invalid-feedback"
                      style="display: block"
                    >
                      <span class="border-red">{{ errors[0] }}</span>
                    </div>
                  </validation-provider>
                </td>
              </tr>
              <tr>
                <th>
                  名変輸送サービスを
                  <br v-if="isMobile" />
                  希望しますか？
                  <span class="must">必須</span>
                </th>
                <td>
                  <div class="row">
                    <div class="col-md-4 col-lg-3">
                      <validation-provider
                        v-slot="{ errors }"
                        name="MEIHEN_FLG"
                      >
                        <b-form-select
                          ref="MEIHEN_FLG"
                          v-model="form.MEIHEN_FLG"
                          :state="errors.length ? false : null"
                          :options="yesNoHopeList"
                          :disabled="calculated"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="Number(form.MEIHEN_FLG)">
                <th>
                  軽自動車ですか？
                  <span class="must">必須</span>
                </th>
                <td>
                  <div class="row">
                    <div class="col-md-3">
                      <validation-provider
                        v-slot="{ errors }"
                        name="MEIHEN_KEI_FLG"
                      >
                        <b-form-select
                          ref="MEIHEN_KEI_FLG"
                          v-model="syaryo.MEIHEN_KEI_FLG"
                          :state="errors.length ? false : null"
                          :options="yesNoList"
                          :disabled="calculated"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                </td>
              </tr>
              <tr
                v-if="Number(form.MEIHEN_FLG) && !Number(syaryo.MEIHEN_KEI_FLG)"
              >
                <th v-if="rikujiMei">
                  <p>
                    管轄運輸支局・検査登録事務所は
                    <br />
                    <span class="red">{{ rikujiMei }}</span>
                    でお間違いないですか？
                  </p>
                  <p>異なる場合は右を選択</p>
                </th>
                <th v-else>
                  <p>
                    管轄運輸支局・検査登録事務所
                    <span class="must">必須</span>
                  </p>
                </th>
                <td>
                  <div class="row">
                    <div class="col-md-5 col-lg-3 mt-2 mt-lg-0">
                      <validation-provider
                        v-slot="{ errors, touched }"
                        name="MEIHEN_UNYU_SIKYOKU_SHIKU_CD"
                        rules="required"
                      >
                        <select
                          ref="MEIHEN_UNYU_SIKYOKU_SHIKU_CD"
                          :class="[
                            'form-control form-input',
                            {
                              'border-red':
                                (isVlidated || touched) && errors.length,
                            },
                          ]"
                          v-model="syaryo.MEIHEN_UNYU_SIKYOKU_SHIKU_CD"
                          @change="setRikujiMei"
                          :disabled="calculated"
                        >
                          <option value="">未選択</option>
                          <option
                            v-for="item in rikujiList[
                              Number(syaryo.MEIHEN_KEI_FLG)
                            ]"
                            :value="item.SHIKU_CD"
                            :key="item.ID"
                          >
                            {{ item.RIKUJI_RYAKUSYO }}
                          </option>
                        </select>
                        <div
                          v-if="(isVlidated || touched) && errors.length"
                          class="invalid-feedback"
                          style="display: block"
                        >
                          <span class="border-red">{{ errors[0] }}</span>
                        </div>
                      </validation-provider>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="isLease || Number(form.MEIHEN_FLG)">
                <th>
                  自走してもよろしいですか？
                  <span class="must">必須</span>
                </th>
                <td>
                  <div class="row">
                    <div class="col-md-5 col-lg-3">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required"
                        name="JISOU_KBN"
                      >
                        <b-form-select
                          ref="JISOU_KBN"
                          v-model="syaryo.JISOU_KBN"
                          :state="errors.length ? false : null"
                          :disabled="calculated"
                          :options="jisouKbnList"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  以下の項目に
                  <br v-if="isMobile" />
                  当てはまりますか？
                  <span class="must">必須</span>
                </th>
                <td>
                  <div class="row">
                    <div class="col-md-3">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required"
                        name="JYOTAI_FLG"
                      >
                        <b-form-select
                          ref="JYOTAI_FLG"
                          v-model="syaryo.JYOTAI_FLG"
                          :state="errors.length ? false : null"
                          :disabled="calculated"
                          :options="yesNoList"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="mt-3">
                    <ul class="mb-0">
                      <li v-if="!isLease && Number(!form.MEIHEN_FLG)">
                        自走不可（不動車・新古車）
                      </li>
                      <li>ローダウン（地面からの距離15cm以下）</li>
                      <li>高額車（車両価格500万円以上）</li>
                      <li>クラシックカー（製造年が1989年以前）</li>
                      <li>改造車（車検が通らないもの）</li>
                    </ul>
                  </div>
                </td>
              </tr>
              <tr>
                <th>長さ・幅・高さ(cm)</th>
                <td>
                  <div class="row mr-1 mb-2">
                    <div class="col-4 col-md-3 pr-0">
                      <div class="row">
                        <label
                          class="col-4 col-md-5 col-lg-4 mt-2 ml-md-1 pr-0"
                        >
                          長さ
                        </label>
                        <validation-provider
                          name="SYARYO_NAGASA"
                          v-slot="{ errors }"
                          rules="numeric|max:4"
                          class="col-8 col-md-6 px-md-0"
                        >
                          <b-form-input
                            ref="SYARYO_NAGASA"
                            type="tel"
                            maxlength="4"
                            v-model="syaryo.SYARYO_NAGASA"
                            :state="errors.length ? false : null"
                            :disabled="calculated"
                            placeholder="450"
                            trim
                          />
                          <b-form-invalid-feedback>
                            <span class="border-red">{{ errors[0] }}</span>
                          </b-form-invalid-feedback>
                        </validation-provider>
                      </div>
                    </div>
                    <div class="col-4 col-md-3 pr-0">
                      <div class="row">
                        <label
                          class="col-3 col-md-4 col-lg-3 mt-2 ml-md-1 pr-0"
                        >
                          幅
                        </label>
                        <validation-provider
                          name="SYARYO_HABA"
                          v-slot="{ errors }"
                          rules="numeric|max:3"
                          class="col-8 col-md-6 px-md-0"
                        >
                          <b-form-input
                            ref="SYARYO_HABA"
                            type="tel"
                            maxlength="3"
                            v-model="syaryo.SYARYO_HABA"
                            :state="errors.length ? false : null"
                            :disabled="calculated"
                            placeholder="170"
                            trim
                          />
                          <b-form-invalid-feedback>
                            <span class="border-red">{{ errors[0] }}</span>
                          </b-form-invalid-feedback>
                        </validation-provider>
                      </div>
                    </div>
                    <div class="col-4 col-md-3 px-0">
                      <div class="row">
                        <label
                          class="col-4 col-md-5 col-lg-4 mt-2 ml-md-1 pr-0"
                        >
                          高さ
                        </label>
                        <validation-provider
                          name="SYARYO_TAKASA"
                          v-slot="{ errors }"
                          rules="numeric|max:3"
                          class="col-8 col-md-6 px-md-0"
                        >
                          <b-form-input
                            ref="SYARYO_TAKASA"
                            type="tel"
                            maxlength="3"
                            v-model="syaryo.SYARYO_TAKASA"
                            :state="errors.length ? false : null"
                            :disabled="calculated"
                            placeholder="140"
                            trim
                          />
                          <b-form-invalid-feedback>
                            <span class="border-red">{{ errors[0] }}</span>
                          </b-form-invalid-feedback>
                        </validation-provider>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </section>
      </div>

      <h4 class="page-sub-title pl-2 pl-md-4 mt-5">引取先・納車先</h4>
      <section id="trial-address">
        <div class="row mt-1 mx-auto">
          <div
            :class="[
              'row col-md-6 bottom-1 mx-auto',
              {
                'border-red': isVlidated && !getSelectedHN('HIKITORI').TODO_CD,
              },
            ]"
          >
            <dl v-if="isHikitoriSet">
              <dt class="p-2">引取先</dt>
              <dd
                v-if="getSelectedHN('HIKITORI').MEI"
                class="text-left mt-4 ml-5"
              >
                <span>{{ getSelectedHN('HIKITORI').MEI }}</span>
              </dd>
              <dd v-else class="text-left mt-4 ml-5"><span>&emsp;</span></dd>
              <dd class="text-left mt-1 ml-5">
                <span>{{ getSelectedAddressHN('HIKITORI') }}</span>
              </dd>
              <div class="row">
                <div class="col-md-6">
                  <dd
                    v-if="
                      isDirectH && Number(getSelectedHN('HIKITORI').IS_PERSONAL)
                    "
                    class="text-left mt-1 ml-5"
                  >
                    <span>※個人宅</span>
                  </dd>
                  <dd v-else class="text-left mt-1 ml-5">
                    <span>&emsp;</span>
                  </dd>
                </div>
                <div class="col-md-6 text-center">
                  <md-button
                    type="button"
                    class="
                      md-raised
                      btn-lg btn-success
                      base-btn
                      col-8 col-md-11
                    "
                    @click="
                      selectedHNName = 'hikitori'
                      showMenuModal = true
                    "
                    :disabled="calculated"
                  >
                    引取先を選択
                  </md-button>
                </div>
              </div>
            </dl>
            <dl v-else>
              <dt class="p-2">引取先</dt>
              <dd class="text-center mt-3">
                <md-button
                  type="button"
                  class="md-raised btn-lg btn-success base-btn address-btn-1"
                  @click="
                    selectedHNName = 'hikitori'
                    showMenuModal = true
                  "
                  :disabled="calculated"
                >
                  引取先を選択
                </md-button>
              </dd>
              <dd
                v-if="isVlidated && !getSelectedHN('HIKITORI').TODO_CD"
                class="err-message ml-4 pl-2 f-size-16"
              >
                入力必須です
              </dd>
            </dl>
          </div>
          <div
            :class="[
              'row col-md-6 bottom-1 mx-auto',
              { 'border-red': isVlidated && !getSelectedHN('NOSYA').TODO_CD },
            ]"
          >
            <dl v-if="isNosyaSet">
              <dt class="p-2">納車先</dt>
              <dd v-if="getSelectedHN('NOSYA').MEI" class="text-left mt-4 ml-5">
                <span>{{ getSelectedHN('NOSYA').MEI }}</span>
              </dd>
              <dd v-else class="text-left mt-4 ml-5"><span>&emsp;</span></dd>
              <dd class="text-left mt-1 ml-5">
                <span>{{ getSelectedAddressHN('NOSYA') }}</span>
              </dd>
              <div class="row">
                <div class="col-md-6">
                  <dd
                    v-if="
                      isDirectN && Number(getSelectedHN('NOSYA').IS_PERSONAL)
                    "
                    class="text-left mt-1 ml-5"
                  >
                    <span>※個人宅</span>
                  </dd>
                  <dd v-else class="text-left mt-1 ml-5">
                    <span>&emsp;</span>
                  </dd>
                </div>
                <div class="col-md-6 text-center">
                  <md-button
                    type="button"
                    class="
                      md-raised
                      btn-lg btn-success
                      base-btn
                      col-8 col-md-11
                    "
                    @click="
                      selectedHNName = 'nosya'
                      showMenuModal = true
                    "
                    :disabled="calculated"
                  >
                    納車先を選択
                  </md-button>
                </div>
              </div>
            </dl>
            <dl v-else>
              <dt class="p-2">納車先</dt>
              <dd class="text-center mt-3">
                <md-button
                  type="button"
                  class="md-raised btn-lg btn-success base-btn address-btn-1"
                  @click="
                    selectedHNName = 'nosya'
                    showMenuModal = true
                  "
                  :disabled="calculated"
                >
                  納車先を選択
                </md-button>
              </dd>
              <dd
                v-if="isVlidated && !getSelectedHN('NOSYA').TODO_CD"
                class="err-message ml-4 pl-2 f-size-16"
              >
                入力必須です
              </dd>
            </dl>
          </div>
        </div>
      </section>

      <h4
        v-if="Number(form.MEIHEN_FLG) || isLease"
        class="page-sub-title pl-2 pl-md-4 mt-5"
      >
        オプション
      </h4>
      <div
        v-if="Number(form.MEIHEN_FLG) || isLease"
        class="section-wrapper bg-gray"
      >
        <section class="order-option">
          <div class="section-child">
            <h5 class="_page-sub-title pl-2 pl-md-4 mt-2">清掃サービス</h5>
            <table class="table">
              <tr>
                <th>清掃サービス</th>
                <td>
                  <div class="row">
                    <div class="col-md-4 col-lg-3">
                      <validation-provider
                        v-slot="{ errors }"
                        name="SEISOU_FLG"
                      >
                        <b-form-select
                          ref="SEISOU_FLG"
                          v-model="syaryo.SEISOU_FLG"
                          :state="errors.length ? false : null"
                          :options="yesNoHopeList"
                          :disabled="calculated"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                  <p
                    v-if="Number(form.MEIHEN_FLG) && Number(syaryo.SEISOU_FLG)"
                    class="mt-1 red f-size-14"
                  >
                    ※別途実費ご請求
                  </p>
                </td>
              </tr>
              <tr v-if="Number(syaryo.SEISOU_FLG)">
                <th>
                  清掃内容
                  <span class="must">必須</span>
                </th>
                <td>
                  <div v-if="!isLease" class="p-1">
                    <div class="form-check form-check-inline col-md-12 py-1">
                      <input
                        ref="SEISOU_KBN"
                        class="form-check-input"
                        type="radio"
                        id="seisou-flg-1"
                        value="2"
                        v-model="syaryo.SEISOU_KBN"
                        :disabled="calculated"
                      />
                      <label class="form-check-label" for="seisou-flg-1">
                        手洗い
                      </label>
                    </div>
                    <div class="form-check form-check-inline col-md-12 py-1">
                      <input
                        ref="SEISOU_KBN"
                        class="form-check-input"
                        type="radio"
                        id="seisou-flg-2"
                        value="1"
                        v-model="syaryo.SEISOU_KBN"
                        :disabled="calculated"
                      />
                      <label class="form-check-label" for="seisou-flg-2">
                        洗車機
                      </label>
                    </div>
                  </div>
                  <div v-else class="p-1">
                    <div
                      v-if="syaryo.SYARYO_TYPE_KBN === 1"
                      class="form-check form-check-inline col-md-12 py-1"
                    >
                      <input
                        ref="SEISOU_KBN"
                        class="form-check-input"
                        type="radio"
                        id="seisou-flg-2"
                        value="10"
                        v-model="syaryo.SEISOU_KBN"
                        :disabled="calculated"
                      />
                      <label class="form-check-label" for="seisou-flg-2">
                        スタンド立寄り洗車（簡易車外と室内）
                      </label>
                    </div>
                    <div
                      v-if="syaryo.SYARYO_TYPE_KBN === 1"
                      class="form-check form-check-inline col-md-12 py-1"
                    >
                      <input
                        ref="SEISOU_KBN"
                        class="form-check-input"
                        type="radio"
                        id="seisou-flg-1"
                        value="11"
                        v-model="syaryo.SEISOU_KBN"
                        :disabled="calculated"
                      />
                      <label class="form-check-label" for="seisou-flg-1">
                        ヤード内での洗車（車外・室内）
                      </label>
                    </div>
                    <div class="form-check form-check-inline col-md-12 py-1">
                      <input
                        ref="SEISOU_KBN"
                        class="form-check-input"
                        type="radio"
                        id="seisou-flg-10"
                        value="12"
                        v-model="syaryo.SEISOU_KBN"
                        :disabled="calculated"
                      />
                      <label class="form-check-label" for="seisou-flg-10">
                        室内清掃（ダスキン標準） 15,000円～
                      </label>
                    </div>
                    <div class="form-check form-check-inline col-md-12 py-1">
                      <input
                        ref="SEISOU_KBN"
                        class="form-check-input"
                        type="radio"
                        id="seisou-flg-11"
                        value="13"
                        v-model="syaryo.SEISOU_KBN"
                        :disabled="calculated"
                      />
                      <label class="form-check-label" for="seisou-flg-11">
                        室内清掃（ダスキンスペシャル） 28,000円～
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
            </table>

            <h5
              v-if="isLease || Number(form.MEIHEN_FLG)"
              class="page-sub-title pl-2 pl-md-4 mt-3 mt-md-4"
            >
              保管
            </h5>
            <table v-if="isLease || Number(form.MEIHEN_FLG)" class="table">
              <tr>
                <th>保管のご希望</th>
                <td>
                  <div class="row">
                    <div class="col-md-4 col-lg-3">
                      <validation-provider name="HOKAN_FLG" v-slot="{ errors }">
                        <b-form-select
                          ref="HOKAN_FLG"
                          v-model="syaryo.HOKAN_FLG"
                          :state="errors.length ? false : null"
                          :options="yesNoHopeList"
                          :disabled="calculated"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                </td>
              </tr>
            </table>

            <h5
              v-if="Number(form.MEIHEN_FLG)"
              class="page-sub-title pl-2 pl-md-4 mt-4"
            >
              ETC車載器セットアップ
            </h5>
            <table v-if="Number(form.MEIHEN_FLG)" class="table">
              <tr>
                <th>ETC車載器セットアップのご希望</th>
                <td>
                  <div class="row">
                    <div class="col-md-4 col-lg-3">
                      <validation-provider
                        v-slot="{ errors }"
                        name="ETC_SETUP_FLG"
                      >
                        <b-form-select
                          ref="ETC_SETUP_FLG"
                          v-model="syaryo.ETC_SETUP_FLG"
                          :state="errors.length ? false : null"
                          :options="etcHopeList"
                          :disabled="calculated"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                  <p
                    v-if="!isLease && Number(syaryo.ETC_SETUP_FLG)"
                    class="mt-1 red f-size-14"
                  >
                    ※料金5,000円と別途実費ご請求
                  </p>
                </td>
              </tr>
            </table>

            <h5
              v-if="isLease && Number(form.MEIHEN_FLG)"
              class="page-sub-title pl-2 pl-md-4 mt-4"
            >
              車庫証明申請受領代行
            </h5>
            <table v-if="isLease && Number(form.MEIHEN_FLG)" class="table">
              <tr>
                <th>車庫証明申請受領代行のご希望</th>
                <td>
                  <div class="row">
                    <div class="col-md-4 col-lg-3">
                      <validation-provider
                        v-slot="{ errors }"
                        name="SYAKOSYO_JYURYO_FLG"
                      >
                        <b-form-select
                          ref="SYAKOSYO_JYURYO_FLG"
                          v-model="syaryo.SYAKOSYO_JYURYO_FLG"
                          :state="errors.length ? false : null"
                          :options="yesNoHopeList"
                          :disabled="calculated"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                  <p
                    v-if="!isLease && Number(syaryo.SYAKOSYO_JYURYO_FLG)"
                    class="mt-1 red f-size-14"
                  >
                    ※料金{{
                      Number(syaryo.MEIHEN_KEI_FLG) ? '10,000' : '15,000'
                    }}円と別途印紙代ご請求
                  </p>
                </td>
              </tr>
            </table>

            <h5
              v-if="Number(form.MEIHEN_FLG)"
              class="page-sub-title pl-2 pl-md-4 mt-4"
            >
              希望ナンバー
            </h5>
            <table v-if="Number(form.MEIHEN_FLG)" class="table">
              <tr>
                <th>
                  希望ナンバーのご希望
                  <br />
                  <span class="f-size-12">※ ナンバー代は別途ご請求</span>
                </th>
                <td>
                  <div class="row">
                    <div class="col-md-4 col-lg-3">
                      <validation-provider
                        name="MEIHEN_KIBO_NUMBER_FLG"
                        v-slot="{ errors }"
                        rules="required|max:4|numeric"
                      >
                        <b-form-select
                          ref="MEIHEN_KIBO_NUMBER_FLG"
                          v-model="syaryo.MEIHEN_KIBO_NUMBER_FLG"
                          :state="errors.length ? false : null"
                          :options="yesNoHopeList"
                          :disabled="calculated"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                  <p
                    v-if="!isLease && Number(syaryo.MEIHEN_KIBO_NUMBER_FLG)"
                    class="mt-1 red f-size-14"
                  >
                    ※料金2,000円と別途ナンバー代ご請求
                  </p>
                </td>
              </tr>
              <tr v-if="Number(syaryo.MEIHEN_KIBO_NUMBER_FLG)">
                <th>希望番号の申請代行のご希望</th>
                <td>
                  <div class="row">
                    <div class="col-md-3">
                      <validation-provider
                        v-slot="{ errors }"
                        name="MEIHEN_KIBO_NUMBER_DAIKO_FLG"
                      >
                        <b-form-select
                          ref="MEIHEN_KIBO_NUMBER_DAIKO_FLG"
                          v-model="syaryo.MEIHEN_KIBO_NUMBER_DAIKO_FLG"
                          :state="errors.length ? false : null"
                          :options="yesNoHopeList"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </section>
      </div>

      <section
        v-if="calculated && !isNotRyokin"
        class="col-md-6 p-3"
        id="trial-calc"
      >
        <div class="row">
          <div class="col-12 bold">
            <div class="row">
              <h4 class="col-6"><b>納期目安</b></h4>
              <h4 class="col-6">
                <b>{{ calcData.noki }}日</b>
              </h4>
            </div>
            <div class="row">
              <h4 class="col-6"><b>お見積もり概算</b></h4>
              <h4 class="col-6">
                <b>{{ Number(calcData.price).toLocaleString() }}円</b>
                <span class="f-size-12">（税別）</span>
              </h4>
            </div>
          </div>
          <div class="ml-3 px-3 mt-2 col-10">
            <b>内訳</b>
            <div
              v-for="(item, index) in calcData.uchiwake"
              :key="index"
              class="row"
            >
              <div class="col-6">{{ item.name }}</div>
              <div v-if="form.MEIHEN_FLG && item.price" class="col-6">
                {{ Number(item.price).toLocaleString() }}円
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4 ml-2 f-size-14">
          <span>※納期は変動することがございます。</span>
          <br />
          <span>
            ※車両状態、その他の条件によって金額が変動することがございます。
          </span>
          <br />
          <span v-if="syaryo.SEISOU_FLG">
            ※清掃代は別途実費請求となります。
          </span>
          <div v-if="form.MEIHEN_FLG">
            <span>
              ※各種税金、自賠責保険、ナンバー代、印紙、証紙代は別途必要です。
            </span>
          </div>
        </div>
      </section>

      <div v-if="!calculated" class="text-center mr-3 mr-md-0">
        <md-button
          type="button"
          class="btn-lg btn-secondary base-btn col-md-2"
          @click="reset"
        >
          リセット
        </md-button>
        <br v-if="isMobile" />
        <md-button
          type="button"
          class="btn-lg btn-success base-btn col-md-2"
          @click="validate"
        >
          計算
        </md-button>
      </div>
      <div v-else class="text-center mt-2 mr-3 mr-md-0">
        <p
          v-if="isNotRyokin"
          :class="['my-3 red text-center bold', { 'f-size-12': isMobile }]"
        >
          この条件の輸送は、都度お見積りとなります。
          <br />
          お見積り履歴画面から、料金をお問い合わせください。
        </p>
        <md-button
          type="button"
          class="btn-lg reset-btn btn-link col-5 col-md-1"
          @click="reset"
        >
          リセット
        </md-button>
        <br v-if="isMobile" />
        <md-button
          type="button"
          class="btn-lg btn-secondary base-btn col-md-2"
          @click="retry"
        >
          再計算
        </md-button>
        <br v-if="isMobile" />
        <md-button
          v-if="!isNotRyokin"
          type="button"
          class="btn-lg btn-success base-btn col-md-4 col-lg-2"
          @click="gotoOrder"
        >
          この条件で発注
        </md-button>
        <md-button
          v-else
          type="button"
          class="btn-lg btn-success base-btn col-md-3"
          @click="openInquiryDialog"
        >
          見積り問い合わせをする
        </md-button>
      </div>

      <!-- 引納先選択メニュー -->
      <md-dialog
        :md-active.sync="showMenuModal"
        class="new"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
      >
        <md-dialog-title>{{ hnParamWaName }}先を選択</md-dialog-title>
        <div class="p-4 text-center">
          <md-button
            type="button"
            class="btn-lg btn-success base-btn col-md-9 mb-2 mb-md-3 m-0"
            @click="showMasterDialog = true"
          >
            登録済みの場所
          </md-button>
          <md-button
            type="button"
            class="btn-lg btn-success base-btn col-md-9 mb-2 mb-md-3 m-0"
            @click="showAuctionDialog = true"
          >
            オークション会場
          </md-button>
          <md-button
            type="button"
            class="btn-lg btn-success base-btn col-md-9 mb-2 mb-md-3 m-0"
            @click="showDirectDialog = true"
          >
            住所を直接入力
          </md-button>
          <md-button
            type="button"
            class="btn-lg btn-success base-btn col-md-9 m-0"
            @click="showFavoriteDialog = true"
          >
            お気に入り
          </md-button>
        </div>
        <md-dialog-actions>
          <md-button class="md-primary" @click="showMenuModal = false">
            閉じる
          </md-button>
        </md-dialog-actions>
      </md-dialog>

      <!-- 登録済みの場所モーダル -->
      <md-dialog
        :md-active.sync="showMasterDialog"
        class="new w-800"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
      >
        <md-dialog-title>登録済みの場所</md-dialog-title>
        <div class="px-3">
          <Master
            ref="master"
            class="pt-2 pb-3"
            :form="form[`${hnParamName()}_MASTER`]"
            :hn-param-wa-name="hnParamWaName"
            :is-invalid-active="HikinoInvalidActive[hnParamName()].MASTER"
            @setInvalid="onSetMaster"
          />
          <md-dialog-actions>
            <md-button class="md-primary" @click="showMasterDialog = false">
              閉じる
            </md-button>
            <md-button
              class="md-primary"
              @click="HikinoInvalidActive[hnParamName()].MASTER = true"
            >
              決定
            </md-button>
          </md-dialog-actions>
        </div>
      </md-dialog>

      <!-- オークションのモーダル -->
      <md-dialog
        :md-active.sync="showAuctionDialog"
        class="new w-800"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
      >
        <md-dialog-title>オークション会場</md-dialog-title>
        <div class="px-3">
          <Auction
            ref="auction"
            class="pt-2 pb-3"
            :form="form[`${hnParamName()}_AUCTION`]"
            :hn-param-wa-name="hnParamWaName"
            :is-invalid-active="HikinoInvalidActive[hnParamName()].AUCTION"
            @setInvalid="onSetAuction"
          />
          <md-dialog-actions>
            <md-button class="md-primary" @click="showAuctionDialog = false">
              閉じる
            </md-button>
            <md-button
              class="md-primary"
              @click="HikinoInvalidActive[hnParamName()].AUCTION = true"
            >
              決定
            </md-button>
          </md-dialog-actions>
        </div>
      </md-dialog>

      <!-- 直接入力モーダル -->
      <md-dialog
        :md-active.sync="showDirectDialog"
        class="new w-800"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
      >
        <md-dialog-title>直接入力</md-dialog-title>
        <div class="p-2">
          <Direct
            ref="direct"
            class="pt-2 pb-3"
            :is-meihen="form.MEIHEN_FLG"
            :form="form[`${hnParamName()}_DIRECT`]"
            :is-invalid-active="HikinoInvalidActive[hnParamName()].DIRECT"
            @setInvalid="onSetDirect"
          />
        </div>
        <md-dialog-actions>
          <md-button class="md-primary" @click="showDirectDialog = false">
            閉じる
          </md-button>
          <md-button
            class="md-primary"
            @click="HikinoInvalidActive[hnParamName()].DIRECT = true"
          >
            登録
          </md-button>
        </md-dialog-actions>
      </md-dialog>

      <!-- お気に入りのモーダル -->
      <md-dialog
        :md-active.sync="showFavoriteDialog"
        class="new w-800"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
      >
        <md-dialog-title>お気に入り</md-dialog-title>
        <div class="px-3">
          <favorite
            ref="auction"
            class="pt-2 pb-3"
            :form="form[`${hnParamName()}_FAVORITE`]"
            :hn-param-wa-name="hnParamWaName"
            :is-invalid-active="HikinoInvalidActive[hnParamName()].FAVORITE"
            @setInvalid="onSetFavorite"
          />
          <md-dialog-actions>
            <md-button class="md-primary" @click="showFavoriteDialog = false">
              閉じる
            </md-button>
            <md-button
              class="md-primary"
              @click="HikinoInvalidActive[hnParamName()].FAVORITE = true"
            >
              決定
            </md-button>
          </md-dialog-actions>
        </div>
      </md-dialog>

      <md-dialog-alert
        :md-active.sync="isSent"
        class="new"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="
          scroll('clear')
          reset()
        "
        md-content="<strong>お問い合わせを受け付けました。<br>折り返し弊社担当より連絡いたしますので、少々お待ちください。</strong>"
      />

      <md-dialog-confirm
        :md-active.sync="isYoshiFukaModal"
        md-title=""
        :md-content="getHcbApiErrorMessage('untrust')"
        md-confirm-text="問い合わせる"
        md-cancel-text="キャンセル"
        :md-click-outside-to-close="true"
        @md-confirm="gotoInquiry"
        class="new"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
        @md-cancel="scroll('clear')"
      />

      <inquiry-dialog
        v-if="mitumoriData"
        :mitumori-data="mitumoriData"
        :is-active.sync="isDialogInquiry"
        @success="gotoMitumoriDetail"
      />

      <md-snackbar
        :class="snackbarClass"
        md-position="center"
        :md-active.sync="isSnackbar"
        md-persistent
      >
        <span>{{ snackbarText }}</span>
      </md-snackbar>
    </validation-observer>
  </div>
</template>
<script>
import InquiryDialog from '@/components/estimate/InquiryDialog'
import MitumoriMixin from '@/components/mixin/MitumoriMixin'
import Const from '@/const'
import Store from '@/store/index.js'
import _ from 'lodash'
import moment from 'moment'
import {scroller} from 'vue-scrollto/src/scrollTo'
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css'
import Mixin from '../mixin/Mixin'
import Auction from './Auction'
import Direct from './Direct'
import Favorite from './Favorite'
import Master from './Master'

const firstScrollTo = scroller()
const HIKINO_SAKI = {
  AA_FLG: 0,
  AA_KAISAI_BI: '',
  SHIKI_CD: '',
  YUBIN1: '',
  YUBIN2: '',
  TODO_CD: null,
  TODO_MEI: '',
  SHIKU_CD: '',
  SHIKU_MEI: '',
  BANCHI: '',
  MEI: '',
  TEL: '',
  FAX: '',
  TANTO_MEI: '',
  TANTO_TEL: '',
  TANTO_FAX: '',
  YUSO_KBN: '',
  TEIKYU_BI: '',
  EIGYO_KAISI_JIKAN: '',
  EIGYO_SYURYO_JIKAN: '',
  PLACE_TYPE: '',
}
export default {
  name: 'Complete',
  components: {
    VueSimpleSuggest,
    InquiryDialog,
    Master,
    Auction,
    Direct,
    Favorite,
  },
  mixins: [Mixin, MitumoriMixin],
  data: () => ({
    /** スナックバー表示フラグ */
    isSnackbar: false,

    /**スナックバークラス */
    snackbarClass: 'bg-danger',

    /** スナックバーテキスト */
    snackbarText: null,

    /** お問い合わせDialog表示フラグ */
    isDialogInquiry: false,

    /** 見積データ */
    mitumoriData: null,

    /** オブザーバー */
    observer: null,

    /** 引納先エラー存在取得フラグ */
    HikinoInvalidActive: {
      HIKITORI: {
        MASTER: false,
        DIRECT: false,
        AUCTION: false,
        FAVORITE: false,
      },
      NOSYA: {
        MASTER: false,
        DIRECT: false,
        AUCTION: false,
        FAVORITE: false,
      },
    },

    changedUnyu: false,
    isValid: false,
    // サジェスト設定
    autoCompleteStyle: {
      vueSimpleSuggest: 'position-relative',
      inputWrapper: '',
      defaultInput: 'form-control',
      suggestions: 'position-absolute list-group z-1000',
      suggestItem: 'list-group-item',
    },
    // 計算結果データ
    calcData: {
      price: null,
      noki: null,
      uchiwake: null,
    },
    calculated: false, // 計算が終わったか
    makerList: [], // 車両メーカ一覧
    syameiList: [], // 車名一覧
    _syameiList: [], // 車名一覧
    makerSyameiMap: {}, // メーカー、車名マップ
    rikujiList: [], // 運輸支局リスト
    rikujiMei: '', // 選択中の陸自名称
    form: {},
    _syaryo: {}, // 車両のデフォルト
    syaryo: {},
    selectedHNName: '', // hikitori or nosya
    showMenuModal: false,
    showAddressNosyaDialog: false,
    showMasterDialog: false,
    showAuctionDialog: false,
    showDirectDialog: false,
    showFavoriteDialog: false,
    isSent: false,
    isNotRyokin: null,
    isYoshiFukaModal: false, // 与信不可モーダル表示フラグ
  }),
  methods: {
    /** 見積詳細画面に遷移する */
    gotoMitumoriDetail() {
      this.$router.push({
        name: 'EstimateDetail',
        params: { id: this.mitumoriData.ID },
      })
    },

    /** 問い合わせダイアログを開く */
    openInquiryDialog() {
      // 見積データは saveMitumori で既に設定済み
      this.isDialogInquiry = true
    },

    /** API結果を初期化する */
    initializeCalc() {
      this.calcData = {
        price: null,
        noki: null,
        uchiwake: null,
      }
    },

    /** バリデーション */
    async validate() {
      this.spinerOff()
      const valid = await this.observer.validate()
      if (
        !valid ||
        !this.getSelectedHN('HIKITORI').TODO_CD ||
        !this.getSelectedHN('NOSYA').TODO_CD
      ) {
        this._alert('入力項目にエラーがあります。')
      } else {
        this.cleanup()
        this.initializeCalc()
        this.isEnableCalc ? this.calc() : this.saveMitumori()
      }
    },

    /** 表示された入力データのみ設定する */
    cleanup() {
      const exclude = ['MEIHEN_UNYU_SIKYOKU_SHIKU_CD', 'RIKUJI_MEI']
      for (var name in this.syaryo) {
        if (exclude.includes(name)) continue
        if (!this.$refs[name]) this.syaryo[name] = this._syaryo[name]
      }
    },

    // データ初期化
    initialize() {
      this.isNotRyokin = null
      this.form = {
        // どのモーダルを選択したか
        SELECTED_HIKITORI_MODAL: '',
        SELECTED_NOSYA_MODAL: '',
        // 発注画面で表示するタブ名
        ACTIVE_HIKITORI_TAB: '',
        ACTIVE_NOSYA_TAB: '',
        HIKITORI_IS_MASTER_ACTIVE: true,
        HIKITORI_IS_AUCTION_ACTIVE: false,
        HIKITORI_IS_DIRECT_ACTIVE: false,
        NOSYA_IS_MASTER_ACTIVE: true,
        NOSYA_IS_AUCTION_ACTIVE: false,
        NOSYA_IS_DIRECT_ACTIVE: false,
        // モーダルごとの引納情報
        HIKITORI_MASTER: Object.assign(
          {
            TOROKUBAYO_KO_ID: '',
          },
          HIKINO_SAKI
        ),
        HIKITORI_AUCTION: Object.assign(
          {
            AA_CD: '',
          },
          HIKINO_SAKI
        ),
        HIKITORI_DIRECT: Object.assign({ IS_PERSONAL: null }, HIKINO_SAKI),
        HIKITORI_FAVORITE: _.cloneDeep(HIKINO_SAKI),
        // モーダルごとの納車情報
        NOSYA_MASTER: Object.assign(
          {
            TOROKUBAYO_KO_ID: '',
          },
          HIKINO_SAKI
        ),
        NOSYA_AUCTION: Object.assign(
          {
            AA_CD: '',
          },
          HIKINO_SAKI
        ),
        NOSYA_DIRECT: Object.assign({ IS_PERSONAL: null }, HIKINO_SAKI),
        NOSYA_FAVORITE: _.cloneDeep(HIKINO_SAKI),
        // 共通の引納情報
        MEIHEN_FLG: 0,
      }
      // 計算API用の場所コードを設定
      this.form.HIKITORI_MASTER.PLACE_TYPE = Const.RYOKIN_API_AREA_TYPE.TOROKU
      this.form.NOSYA_MASTER.PLACE_TYPE = Const.RYOKIN_API_AREA_TYPE.TOROKU
      this.form.HIKITORI_DIRECT.PLACE_TYPE =
        Const.RYOKIN_API_AREA_TYPE.AREA
      this.form.NOSYA_DIRECT.PLACE_TYPE = Const.RYOKIN_API_AREA_TYPE.AREA
      this.form.HIKITORI_AUCTION.PLACE_TYPE =
        Const.RYOKIN_API_AREA_TYPE.AUCTION
      this.form.NOSYA_AUCTION.PLACE_TYPE = Const.RYOKIN_API_AREA_TYPE.AUCTION

      this._syaryo = {
        SYARYO_TYPE_KBN: '',
        SYARYO_MEI: '',
        MEIHEN_KEI_FLG: 0,
        MEIHEN_UNYU_SIKYOKU_SHIKU_CD: '',
        RIKUJI_MEI: '',
        JISOU_KBN: 1,
        JYOTAI_FLG: 0,
        SYARYO_NAGASA: '',
        SYARYO_HABA: '',
        SYARYO_TAKASA: '',
        SEISOU_FLG: 0,
        SEISOU_KBN: this.isLease ? 12 : 2,
        HOKAN_FLG: 0,
        ETC_SETUP_FLG: 0,
        SYAKOSYO_JYURYO_FLG: 0,
        MEIHEN_KIBO_NUMBER_FLG: 0,
        MEIHEN_KIBO_NUMBER_DAIKO_FLG: 0,
      }
      this.syaryo = _.cloneDeep(this._syaryo)

      /** 料金APIの結果 */
      this.calcData = {
        price: null,
        noki: null,
        uchiwake: null,
      }
      this.calculated = false
    },
    // 登録済みの場所から選択した時
    onSetMaster(invalid) {
      const hikino = this.hnParamName()
      this.HikinoInvalidActive[hikino].MASTER = false
      if (invalid) return this._alert('１件選択してください。', false)
      this.form[`SELECTED_${hikino}_MODAL`] = 'MASTER'
      this.changeActiveTab(hikino, 'MASTER', this.form)
      this.setRikujiVal(hikino)
      this.showMenuModal = false
      this.showMasterDialog = false
      this.showFavoriteDialog = false
    },
    // オークション会場から選択した時
    onSetAuction(invalid) {
      const hikino = this.hnParamName()
      this.HikinoInvalidActive[hikino].AUCTION = false
      if (invalid) return this._alert('１件選択してください。', false)
      this.form[`SELECTED_${hikino}_MODAL`] = 'AUCTION'
      this.changeActiveTab(hikino, 'AUCTION', this.form)
      this.setRikujiVal(hikino)
      this.showMenuModal = false
      this.showAuctionDialog = false
      this.showFavoriteDialog = false
    },
    // 直接入力を選択した時
    onSetDirect(invalid) {
      const hikino = this.hnParamName()
      this.HikinoInvalidActive[hikino].DIRECT = false
      if (invalid) return
      this.form[`SELECTED_${hikino}_MODAL`] = 'DIRECT'
      this.changeActiveTab(hikino, 'DIRECT', this.form)
      this.setRikujiVal(hikino)
      this.showMenuModal = false
      this.showDirectDialog = false
      this.showFavoriteDialog = false
    },
    // お気に入りを選択した時
    onSetFavorite(invalid) {
      const hikino = this.hnParamName()
      this.HikinoInvalidActive[hikino].FAVORITE = false
      if (invalid) return this._alert('１件選択してください。', false)
      this.form[`SELECTED_${hikino}_MODAL`] = 'FAVORITE'
      // PLACE_TYPEとSHIKI_CDを設定
      this.setFavoritePlaceType(this.form[`${hikino}_FAVORITE`])
      this.changeActiveTab(hikino, 'FAVORITE', this.form)
      this.setRikujiVal(hikino)
      this.showMenuModal = false
      this.showDirectDialog = false
      this.showFavoriteDialog = false
    },
    // 納車先選択時、陸事の値を設定
    setRikujiVal(hikino) {
      if (hikino === 'NOSYA' && !this.changedUnyu) {
        const list = this.rikujiList[0]
        const tab = this.form.ACTIVE_NOSYA_TAB
        const nosya = this.form[`NOSYA_${tab}`]
        const rikuji = this.getRikujiDefault(list, nosya.TODO_MEI, nosya.SHIKU_MEI)
        if (rikuji) {
          this.syaryo.MEIHEN_UNYU_SIKYOKU_SHIKU_CD = rikuji.SHIKU_CD
          this.rikujiMei = rikuji.RIKUJI_RYAKUSYO
        }
      }
    },
    // 陸事名称を設定
    setRikujiMei() {
      const shikuCd = this.syaryo.MEIHEN_UNYU_SIKYOKU_SHIKU_CD
      this.rikujiMei = ''
      for (const item of this.rikujiList[Number(this.syaryo.MEIHEN_KEI_FLG)]) {
        if (item.SHIKU_CD === shikuCd) {
          this.rikujiMei = item.RIKUJI_RYAKUSYO
          break
        }
      }
      this.changedUnyu = Boolean(this.rikujiMei)
    },
    // 車名一覧データ設定
    setSyameiList() {
      this.getSyaryoMakerList()
        .then((res) => {
          const list = []
          for (const item of res.data) {
            for (const item2 of item.kensaku_syamei) {
              list.push(item2.SYAMEI)
            }
          }
          this._syameiList = list
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // 車名一覧データ設定
    changeSyameiList() {
      // 普通車の場合のみ車名サジェストを行う
      const syaryoType = this.syaryo.SYARYO_TYPE_KBN
      this.syameiList = Number(syaryoType) === 1 ? this._syameiList : []
    },
    // 管轄運輸支局データ設定
    setRikujiList() {
      this.getRikujiList()
        .then((res) => {
          this.rikujiList = res.data
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    getSelectedHN(hnParamName) {
      const tab = this.form[`ACTIVE_${hnParamName}_TAB`]
      return this.form[`${hnParamName}_${tab}`]
    },
    getSelectedAddressHN(hnParamName) {
      const d = this.getSelectedHN(hnParamName)
      if (!d) return false
      let address = ''
      if (d.TODO_MEI) address += d.TODO_MEI
      if (d.SHIKU_MEI) address += d.SHIKU_MEI
      if (d.BANCHI) address += d.BANCHI
      return address
    },
    hnParamName() {
      return this.selectedHNName === 'hikitori' ? 'HIKITORI' : 'NOSYA'
    },

    /** 発注する */
    gotoOrder() {
      // 与信不可モーダルを表示
      if (this.isYoshinFuka) {
        this.isYoshiFukaModal = true
        return
      }
      this.mitumoriOrder(this.mitumoriData.ID)
    },

    /** リセット */
    reset() {
      this.observer.reset()
      this.initialize()
      firstScrollTo('#page-top')
    },

    /** 再計算 */
    retry() {
      this.observer.reset()
      this.calculated = false
      firstScrollTo('#page-top')
    },

    /** 料金・納期を取得する */
    async calc() {
      this.spinerOn()
      this.syaryo.RIKUJI_MEI = this.rikujiMei
      const hikitori = this.getSelectedHN('HIKITORI')
      const nosya = this.getSelectedHN('NOSYA')
      const data = {
        syaryo: this.syaryo,
        hikitori,
        nosya,
        JYUCYU_SHIKI_CD: Store.state.user.data.JYUCYU_SHIKI_CD,
        MEIHEN_FLG: this.form.MEIHEN_FLG,
      }
      await Store.dispatch('mitumori/ryokin', data)
        .then((data) => {
          if (!Number(data.result_code)) {
            this.calcData = {
              price: data.result_price,
              noki: data.result_noki,
              uchiwake: data.result_uchiwake,
            }
          }
          this.saveMitumori()
        })
        .catch((err) => {
          this.snackbarText = 'エラーが発生しました code: 302'
          this.isSnackbar = true
        })
      this.scroll('clear')
      this.spinerOff()
    },

    /** 見積データを登録する */
    saveMitumori() {
      const syaryo = this.syaryo
      const tanto = this.tanto
      const torihiki = tanto.hum_torihiki
      const hikitori = this.getSelectedHN('HIKITORI')
      const nosya = this.getSelectedHN('NOSYA')
      this.isNotRyokin = Number(this.calcData.price) === 0
      let name = null
      if (tanto.TANTO_MEI_SEI && tanto.TANTO_MEI)
        name = `${tanto.TANTO_MEI_SEI} ${tanto.TANTO_MEI}`
      else if (tanto.TANTO_MEI_SEI) name = tanto.TANTO_MEI_SEI
      else if (tanto.TANTO_MEI) name = tanto.TANTO_MEI
      const data = {
        NAVI_RYOKIN: !this.isNotRyokin ? Number(this.calcData.price) : 0,
        RYOKIN: !this.isNotRyokin ? Number(this.calcData.price) : null,
        NOUKI: !this.isNotRyokin ? `${this.calcData.noki} 日` : null,
        SHITAGAKI_FLG: 0,
        STATUS: !this.isNotRyokin
          ? Const.status.kaitou
          : Const.status.mitoiawase,
        HIKITORI_AA_CD: hikitori.AA_CD || null,
        HIKITORI_TOROKU_ID: hikitori.TOROKUBAYO_KO_ID || null,
        HIKITORI_FAVORITE_ID: hikitori.FAVORITE_ID || null,
        HIKITORI_YUBIN1: hikitori.YUBIN1 || null,
        HIKITORI_YUBIN2: hikitori.YUBIN2 || null,
        HIKITORI_TODO_CD: hikitori.TODO_CD || null,
        HIKITORI_TODO_MEI: hikitori.TODO_MEI || null,
        HIKITORI_SHIKU_CD: hikitori.SHIKU_CD || null,
        HIKITORI_SHIKU_MEI: hikitori.SHIKU_MEI || null,
        HIKITORI_BANCHI: hikitori.BANCHI || null,
        HIKITORI_MEI: hikitori.MEI || null,
        HIKITORI_TEL: hikitori.TEL || null,
        HIKITORI_KOJIN_FLG: hikitori.IS_PERSONAL || null,
        NOSYA_AA_CD: nosya.AA_CD || null,
        NOSYA_TOROKU_ID: nosya.TOROKUBAYO_KO_ID || null,
        NOSYA_FAVORITE_ID: nosya.FAVORITE_ID || null,
        NOSYA_YUBIN1: nosya.YUBIN1 || null,
        NOSYA_YUBIN2: nosya.YUBIN2 || null,
        NOSYA_TODO_CD: nosya.TODO_CD || null,
        NOSYA_TODO_MEI: nosya.TODO_MEI || null,
        NOSYA_SHIKU_CD: nosya.SHIKU_CD || null,
        NOSYA_SHIKU_MEI: nosya.SHIKU_MEI || null,
        NOSYA_BANCHI: nosya.BANCHI || null,
        NOSYA_MEI: nosya.MEI || null,
        NOSYA_TEL: nosya.TEL || null,
        NOSYA_KOJIN_FLG: nosya.IS_PERSONAL || null,
        TORIHIKI_JYUCYU_SHIKI_CD: torihiki.JYUCYU_SHIKI_CD,
        TORIHIKI_SAKI_MEI: torihiki.TORIHIKI_SAKI_MEI,
        TORIHIKI_TANTO_MEI: name,
        TORIHIKI_TEL: torihiki.HCB_JYUCYU_SAKI_TEL,
        MEIHEN_FLG: this.form.MEIHEN_FLG,
        NORMAL_FLG: Number(!syaryo.JYOTAI_FLG),
        SYARYO_TYPE_KBN: syaryo.MEIHEN_KEI_FLG
          ? Const.syaryoTypeKbn.kei
          : syaryo.SYARYO_TYPE_KBN,
        SYARYO_MEI: syaryo.SYARYO_MEI,
        NAGASA: syaryo.SYARYO_NAGASA,
        HABA: syaryo.SYARYO_HABA,
        TAKASA: syaryo.SYARYO_TAKASA,
        RIKUJI_MEI: this.$refs.MEIHEN_UNYU_SIKYOKU_SHIKU_CD
          ? this.rikujiMei
          : null,
        JISOU_KBN: this.$refs.JISOU_KBN ? syaryo.JISOU_KBN : null,
        SEISOU_FLG: this.$refs.SEISOU_FLG ? syaryo.SEISOU_FLG : null,
        SEISOU_KBN: this.$refs.SEISOU_KBN ? syaryo.SEISOU_KBN : null,
        HOKAN_FLG: this.$refs.HOKAN_FLG ? syaryo.HOKAN_FLG : null,
        ETC_SETUP_FLG: this.$refs.ETC_SETUP_FLG ? syaryo.ETC_SETUP_FLG : null,
        SYAKOSYO_JYURYO_FLG: this.$refs.SYAKOSYO_JYURYO_FLG
          ? syaryo.SYAKOSYO_JYURYO_FLG
          : null,
        KIBO_NUMBER_FLG: this.$refs.MEIHEN_KIBO_NUMBER_FLG
          ? syaryo.MEIHEN_KIBO_NUMBER_FLG
          : null,
        MEIHEN_KIBO_NUMBER_DAIKO_FLG: this.$refs.MEIHEN_KIBO_NUMBER_DAIKO_FLG
          ? syaryo.MEIHEN_KIBO_NUMBER_DAIKO_FLG
          : null,

        LIMITED_NICHIJI: syaryo.SHITAGAKI_FLG
          ? null
          : moment().add(30, 'days').format('YYYY-MM-DD'),

        YUSENDO: '中',
      }

      if (this.calcData.uchiwake) {
        data['uchiwake'] = this.calcData.uchiwake.map((v) => {
          return {
            UCHIWAKE_NAME: v.name,
            UCHIWAKE_PRICE: v.price,
          }
        })
      }

      return Store.dispatch('mitumori/add', data)
        .then((res) => {
          // 見積データを保存
          this.mitumoriData = {
            ID: res.data.ID,
            MITUMORI_BANGO: res.data.MITUMORI_BANGO,
            STATUS: res.data.STATUS,
          }
          this.calculated = true
        })
        .catch(() => {
          this.snackbarText = 'エラーが発生しました code: 303'
          this.isSnackbar = true
        })
    },

    setSeisoOpt() {
      if (
        this.isLease &&
        this.syaryo.SYARYO_TYPE_KBN !== 1 &&
        (Number(this.syaryo.SEISOU_KBN) === 10 ||
          Number(this.syaryo.SEISOU_KBN) === 11)
      ) {
        this.syaryo.SEISOU_KBN = 12
      }
    },

    /**
     * 見積りデータから画面を復元する
     */
    async restoreFromMitumori() {
      const mitumoriData = this.$route.params.mitumoriData
      if (!mitumoriData) {
        return
      }

      // formが初期化されていない場合は処理を中断
      if (!this.form || !this.form.HIKITORI_MASTER) {
        return
      }

      this.spinerOn()
      // 車両データを復元（陸自リストを渡してコードも設定）
      const syaryoData = this.createSyaryoDataFromMitumori(mitumoriData, this.rikujiList)
      this.syaryo = { ...this.syaryo, ...syaryoData }

      // 管轄運輸支局・検査登録事務所の名称を設定
      if (mitumoriData.RIKUJI_MEI) {
        this.rikujiMei = mitumoriData.RIKUJI_MEI
      }

      // 名変フラグを復元
      if (mitumoriData.MEIHEN_FLG !== undefined) {
        this.form.MEIHEN_FLG = mitumoriData.MEIHEN_FLG
      }

      // 引取先データを復元
      const hikitoriData = this.createHikinoDataFromMitumori(mitumoriData, 'HIKITORI')
      const hikitoriType = this.getMitumoriSyubetu(mitumoriData, 'HIKITORI')

      // 納車先データを復元
      const nosyaData = this.createHikinoDataFromMitumori(mitumoriData, 'NOSYA')
      const nosyaType = this.getMitumoriSyubetu(mitumoriData, 'NOSYA')

      // 引取先のタブと値を設定
      this.form.SELECTED_HIKITORI_MODAL = hikitoriType
      this.form.ACTIVE_HIKITORI_TAB = hikitoriType
      this.form.HIKITORI_IS_MASTER_ACTIVE = hikitoriType === 'MASTER'
      this.form.HIKITORI_IS_AUCTION_ACTIVE = hikitoriType === 'AUCTION'
      this.form.HIKITORI_IS_DIRECT_ACTIVE = hikitoriType === 'DIRECT'

      if (hikitoriType === 'AUCTION') {
        Object.assign(this.form.HIKITORI_AUCTION, hikitoriData)
      } else if (hikitoriType === 'MASTER') {
        Object.assign(this.form.HIKITORI_MASTER, hikitoriData)
      } else if (hikitoriType === 'FAVORITE') {
        Object.assign(this.form.HIKITORI_FAVORITE, hikitoriData)
        // FAVORITEの場合はPLACE_TYPEとSHIKI_CDを設定
        this.setFavoritePlaceType(this.form.HIKITORI_FAVORITE)
      } else {
        Object.assign(this.form.HIKITORI_DIRECT, hikitoriData)
      }

      // 納車先のタブと値を設定
      this.form.SELECTED_NOSYA_MODAL = nosyaType
      this.form.ACTIVE_NOSYA_TAB = nosyaType
      this.form.NOSYA_IS_MASTER_ACTIVE = nosyaType === 'MASTER'
      this.form.NOSYA_IS_AUCTION_ACTIVE = nosyaType === 'AUCTION'
      this.form.NOSYA_IS_DIRECT_ACTIVE = nosyaType === 'DIRECT'

      if (nosyaType === 'AUCTION') {
        Object.assign(this.form.NOSYA_AUCTION, nosyaData)
      } else if (nosyaType === 'MASTER') {
        Object.assign(this.form.NOSYA_MASTER, nosyaData)
      } else if (nosyaType === 'FAVORITE') {
        Object.assign(this.form.NOSYA_FAVORITE, nosyaData)
        // FAVORITEの場合はPLACE_TYPEとSHIKI_CDを設定
        this.setFavoritePlaceType(this.form.NOSYA_FAVORITE)
      } else {
        Object.assign(this.form.NOSYA_DIRECT, nosyaData)
      }

      // 自動計算を実行
      await this.$nextTick()
      this.isEnableCalc ? await this.calc() : await this.saveMitumori()
      this.spinerOff()
    },
  },

  computed: {
    isEnableCalc() {
      return !(
        this.syaryo.SYARYO_TYPE_KBN !== 1 ||
        (this.syaryo.JISOU_KBN && this.syaryo.JISOU_KBN !== 1) ||
        this.syaryo.JYOTAI_FLG ||
        this.syaryo.HOKAN_FLG
      )
    },
    hnParamWaName() {
      return this.selectedHNName === 'hikitori' ? '引取' : '納車'
    },
    isDirectH() {
      return this.form.SELECTED_HIKITORI_MODAL === 'DIRECT'
    },
    isDirectN() {
      return this.form.SELECTED_NOSYA_MODAL === 'DIRECT'
    },
    isNosyaSet() {
      return (
        (this.getSelectedHN('NOSYA') && this.getSelectedHN('NOSYA').MEI) ||
        this.getSelectedAddressHN('NOSYA')
      )
    },
    isHikitoriSet() {
      return (
        (this.getSelectedHN('HIKITORI') &&
          this.getSelectedHN('HIKITORI').MEI) ||
        this.getSelectedAddressHN('HIKITORI')
      )
    },

    /** バリデーション実行済みか */
    isVlidated() {
      return this.observer && this.observer.flags.validated
    },
  },
  watch: {
    form() {
      if (this.calculated) this.calculated = false
    },
    syaryo() {
      if (this.calculated) this.calculated = false
    },
    // 陸自リストがロードされたら自動的にコードを設定
    rikujiList(newList) {
      if (newList && newList.length > 0 && this.syaryo.RIKUJI_MEI && !this.syaryo.MEIHEN_UNYU_SIKYOKU_SHIKU_CD) {
        this.setRikujiCodeFromName(this.syaryo, newList)
      }
    },
  },

  async mounted() {
    this.observer = this.$refs.observer
    await this.restoreFromMitumori()
  },

  created() {
    this.initialize()
    this.setSyameiList()
    this.setRikujiList()
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
.reset-btn
  text-decoration: underline
  vertical-align: bottom
  font-size: 16px
table
  margin: 0
  th
    background: $baseBlueColor
    color: #fff
    width: 32%
    padding: 1.5%
  td
    width: 68%
    background: #fff
section#trial-address
  dl
    width: 100%
    background: $baseGrayColor
  dt
    background: $baseBlueColor
    color: white
    text-align: center
  dd
  .address-btn-1
    width: 90%
    height: 100px
section#trial-calc
  margin: 20px auto
  background: $baseGrayColor
  border: 5px solid $baseBlueColor
  .result-message
    font-size: 24px
  @include sp
    width: 95%
    .result-message
      font-size: 15px
</style>



// WEBPACK FOOTER //
// src/components/trial/Index.vue